import { render, staticRenderFns } from "./SmsPanelSettings.vue?vue&type=template&id=4683d5ba&scoped=true"
import script from "./SmsPanelSettings.vue?vue&type=script&lang=js"
export * from "./SmsPanelSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4683d5ba",
  null
  
)

export default component.exports